import "@hotwired/turbo-rails"
import "./controllers"
import "./choices"

document.addEventListener("turbo:load", function() {
  const params = new URLSearchParams(window.location.search);
  if (params.get('scroll_to')) {
    const element = document.getElementById(params.get('scroll_to'));
    if (element) {
      const rect = element.getBoundingClientRect();
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      const top = rect.top + scrollTop - 20; // 20px above
      window.scrollTo({ top, behavior: "smooth" });

      // Remove the scroll_to parameter from URL
      params.delete('scroll_to');
      const newUrl = params.toString() ?
        `${window.location.pathname}?${params.toString()}` :
        window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    }
  }
});
